const mediaItems = [
  {
    title: '本周热门预告',
    desc: '最新院线大片预告抢先看，精彩不容错过',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20trailer%20scene%20with%20dramatic%20lighting%20and%20play%20button%20overlay%20style%2C%20warm%20red%20and%20gold%20accents%2C%20no%20text%2C%20professional%20film%20production%20aesthetic%2C%20dark%20cinema%20background%20with%20spotlight%2C%20clean%20composition&width=600&height=350&seq=media-trailer&orientation=landscape',
    duration: '02:35',
  },
  {
    title: '幕后精彩花絮',
    desc: '走进片场，揭秘电影拍摄背后的故事',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20camera%20crew%20and%20director%20chair%2C%20warm%20lighting%2C%20no%20text%2C%20documentary%20style%2C%20authentic%20cinema%20atmosphere%2C%20soft%20focus%2C%20professional%20film%20production&width=600&height=350&seq=media-bts&orientation=landscape',
    duration: '05:18',
  },
  {
    title: '深度影评解读',
    desc: '专业影评人带你剖析电影中的隐藏细节',
    img: 'https://readdy.ai/api/search-image?query=Film%20critic%20analysis%20scene%20with%20movie%20frames%20and%20notes%2C%20warm%20desk%20lamp%20lighting%2C%20no%20text%2C%20intellectual%20cinema%20appreciation%20vibe%2C%20clean%20flat%20lay%20composition%2C%20analytical%20aesthetic&width=600&height=350&seq=media-review&orientation=landscape',
    duration: '08:42',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
            影音专区
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            预告、花絮、影评，更多影视内容等你探索
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={`${item.title} - 6080影院高清视频播放`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/10 transition-colors flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 group-hover:scale-110 transition-all">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-1 rounded bg-background-950/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}